import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {lang} from "../../shared/lang/lang.nl";
import {ApiService} from "../../core/api/api.service";
import {
  ForgotPasswordRequestModel,
  ForgotPasswordResponseModel
} from "../../shared/models/forgot-password/forgot-password.model";
import {environment} from "../../../environments/environment";
@Component({
    selector: 'bergh-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  public lang = lang;
  forgotPasswordForm: UntypedFormGroup;
  constructor( private _formBuilder: UntypedFormBuilder,
               private _api: ApiService,
               private _toastr: ToastrService) { }

  ngOnInit(): void {
    this.forgotPasswordForm = this._formBuilder.group({
      'email':['', [Validators.required,Validators.email]]
    })
  }

  //##################################
  //        G E T T E R S
  //##################################

  /**
   * gets the email value
   *
   * @returns string
   */
  public get emailGet(): string {
    return this.forgotPasswordForm.controls['email'].value;
  }

  /**
   * @description method is called on forgot password form submission.
   * @returns void
   */
  public forgotPasswordFormSubmit(): void{
    if (this.forgotPasswordForm.valid) {
      this.forgotPasswordForm.controls['email'].setValue((this.emailGet).trim());
      let forgotPasswordPayload: ForgotPasswordRequestModel = {
        username: this.emailGet
      }
      this._api.request('forgotPassword',forgotPasswordPayload).subscribe((result: ForgotPasswordResponseModel) => {
        this._toastr.success(result.message,'Success', {
          timeOut: environment.TOASTER_TIMEOUT,
          positionClass: environment.TOASTER_POSITION
        })
       this.forgotPasswordForm.reset();
      },(error)=>{
        console.error(error);
      })

    }

  }

}
